export default __webpack_public_path__ + "static/media/Heebo-Regular.4dbbe613.ttf";